var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPinned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m11.8171 1.76145c-1.5476 0-2.60583 1.56302-2.03107 2.99991l1.87687 4.69221c-1.5848 1.06513-2.62961 2.87553-2.62961 4.93123v3.023c0 .5178.41973.9375.9375.9375h4.41111v9.5206c0 .5178.4197.9375.9375.9375s.9375-.4197.9375-.9375v-9.5206h4.4113c.2486 0 .4871-.0987.6629-.2745.1758-.1759.2746-.4143.2746-.663v-3.023c0-2.0557-1.0448-3.8661-2.6297-4.93124l1.8769-4.6922c.5748-1.43689-.4834-2.99991-2.031-2.99991zm-.2902 2.30356c-.0821-.20527.0691-.42856.2902-.42856h7.0048c.2211 0 .3722.22329.2901.42856l-2.1795 5.44893c-.1841.46006.0217.98386.4697 1.19566 1.3782.6517 2.3285 2.0534 2.3285 3.6752v2.0855h-8.8224v-2.0855c0-1.6218.9503-3.0235 2.3285-3.6751.448-.2119.6537-.73569.4697-1.19576z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinned);
export default __webpack_public_path__ + "static/media/icon_pinned.d109ea17d2821fada41f1634617055f0.svg";
export { ForwardRef as ReactComponent };